/** * * Asynchronously loads the component for
Change Password
* */ import { lazyLoad } from "utils/loadable";
export const ChangePassword = lazyLoad(
  () => import("./index"),
  (module) => module.ChangePassword
);
